import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SearchResults from '@/views/SearchResults'
import BookingDetails from '@/views/BookingDetails'
import VisitBookingSearchResults from '@/views/VisitBookingSearchResults'
import VisitBookingDetails from '@/views/VisitBookingDetails'
import MyBookings from '@/views/MyBookings'
import MyBookingDetails from '@/views/MyBookingDetails'
import Account from '@/views/Account'
import Login from '@/views/Login'
import ViewMaps from "@/views/ViewMaps"
import ScanQRCode from "@/views/ScanQRCode"
import Help from "@/views/Help"
import OnsiteDetector from "@/views/OnsiteDetector"
import LoginOptions from "@/views/LoginOptions"
import EmailMobileLogin from "@/views/EmailMobileLogin"
import ValidateOtp from "@/views/ValidateOtp"
import GantryAccessQR from "@/views/GantryAccessQR"
import SeatsAvailability from "@/views/SeatsAvailability"
import SeatsAvailabilities from "@/views/SeatsAvailabilities"

import store from "@/store/index";
import constants from "@/helpers/constants"
import apiHelper from "@/helpers/apiHelper"
import businessLogic from "@/helpers/businessLogic"
import moment from "moment";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: "/login",
    name: 'Login',
    beforeEnter: (to, from, next) => {
      // if (store.getters.authenticated) {
      //   next({ name: 'Home' });
      // } else {
        apiHelper.casAuth()
      // }
    },
  },
  {
    path: '/common/scanqrcode',
    name: 'ScanQRCode',
    component: ScanQRCode,
    props: true
  },
  {
    path: '/new/searchresults',
    name: 'SearchResults',
    component: SearchResults,
  },
  {
    path: '/new/bookingdetails',
    name: 'BookingDetails',
    component: BookingDetails,
    props: true
  },
  {
    path: '/new/visitbookingsearchresults',
    name: 'VisitBookingSearchResults',
    component: VisitBookingSearchResults
  },
  {
    path: '/new/visitbookingbookingdetails',
    name: 'VisitBookingDetails',
    component: VisitBookingDetails
  },
  {
    path: '/common/viewmaps',
    name: 'ViewMaps',
    component: ViewMaps,
    props: true
  },
  {
    path: '/mybookings',
    name: 'MyBookings',
    component: MyBookings,
    props: true
  },
  {
    path: '/mybookings/mybookingdetails',
    name: 'MyBookingDetails',
    component: MyBookingDetails
  },
  {
    path: '/account',
    name: 'Account',
    component: Account
  },
  {
    path: '/common/help',
    name: 'Help',
    component: Help
  },
  {
    path: '/common/onsitedetector',
    name: 'OnsiteDetector',
    component: OnsiteDetector
  },
  {
    path: '/login/options',
    name: 'LoginOptions',
    component: LoginOptions
  },
  {
    path: '/login/emailmobilelogin',
    name: 'EmailMobileLogin',
    component: EmailMobileLogin
  },
  {
    path: '/login/validateotp',
    name: 'ValidateOtp',
    component: ValidateOtp,
    props: true
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/gantryaccessqr/:branchCode?',
    name: 'GantryAccessQR',
    component: GantryAccessQR,
  },
  {
    path: '/seatavailability',
    name: 'SeatsAvailabilities',
    component: SeatsAvailabilities
  },
  {
    path: '/seatavailability/:branchCode?/:areaId?',
    name: 'SeatsAvailability',
    component: SeatsAvailability,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeResolve((to, from, next) => {
  if (store.state.systemDialog) {
    store.commit("updateSystemDialog", null)
    next(false)
    return
  }

  next()
})

// Insert component here if you do not want to trigger login for the page
 const noAuthRouteNames = [
   "Login", "Home", "SearchResults", "BookingDetails", "VisitBookingSearchResults", "VisitBookingDetails", 
   "ViewMaps", "ScanQRCode", "Help", "OnsiteDetector", "LoginOptions", "EmailMobileLogin", "ValidateOtp", 
   "SeatsAvailabilities", "SeatsAvailability"
 ];

//const noAuthRouteNames = [
//  "Login", "Home", "SearchResults", "BookingDetails", "VisitBookingSearchResults", "VisitBookingDetails",
//  "ViewMaps", "ScanQRCode", "Help", "OnsiteDetector", "LoginOptions", "EmailMobileLogin", "ValidateOtp"
//];

const noCheckInRouteNames = ["ScanQRCode"];

router.beforeEach(async (to, from, next) => {
  // console.debug("Route changed", to.path)
  if (window.$settings.showServiceNotAvailablePage) {
    next();
    return;
  }

  // const casAuth = window.$settings.casAuth;
  const casAuthState = store.state.casAuthState; //get dynamic state value from store
  

  if (to.query && to.query.code && (to.query.state === casAuthState)) {
    // console.debug("CAS callback URL detected", to)

    // //Remove CAS ticket from history
    // console.debug("Replace /")
    // router.replace("/")

    const response = await apiHelper.login(to.query.code, window.$settings.casAuth.redirect_uri);

    if (response && response.data) {
      window.$NotFirstRouting = true;

      businessLogic.updateAccountStateAfterLogin(response);

      const preCasAuthState = store.state.preCasAuthState;
      if (preCasAuthState) {
        // console.debug("preCasAuthState.routeName", preCasAuthState.routeName)

        store.commit("updatePreCasAuthState", null)

        // console.debug("Replace /")
        router.replace("/")
        next({ name: preCasAuthState.routeName, query: { reload: true } })
      }
      else {
        next({ name: "Home" })
      }
    } else {
      store.commit("updateResult", {
        show: true,
        success: false,
        title: window.$msg.loginFail,
        message: response,
      });

      if (response === window.$msg.reloginRequired) {
        setTimeout(() => {
          businessLogic.logout();
        }, 3000)
      }
      else {
        next({ name: "Home" })
      }
    }

    // window.$NotFirstRouting = true;

    return;
  }
  else if (!window.$NotFirstRouting) {
    // console.debug("Reload detected", window.$NotFirstRouting)

    //Page reloaded - Get settings. Get user account info if token exists
    const response = await apiHelper.getAccountInfo();

    const successCallback = () => {
      store.commit("updateSettings", response.data.settings);
    };

    const resultCommonResponseHandler = businessLogic.commonResponseHandler(
      response,
      null,
      null,
      null,
      successCallback,
      null,
      true
    );

    if (resultCommonResponseHandler === window.$msg.reloginRequired) {
      next();
      return;
    }
  }

  window.$NotFirstRouting = true;

  //NOTE : if/else below will cause maximum call stack size exceeded error
  //if (store.getters.gantryAccessQrEnabled) {
  //  if (store.state.qrCodeEntry && to.name !== "GantryAccessQR") {
  //    return next({ name: "GantryAccessQR" });
  //  }
  //  else {
  //    return next({ name: 'EmailMobileLogin' });
  //  }
  //}

  if (store.state.qrCodeEntry && to.name !== "GantryAccessQR") {
    return next({ name: "GantryAccessQR" })
  }

  /////////////////////////////////////////////////////////////////////////////////////////
  // NOTE : comment from seat availability changes start - seat availability changes end //
  //        to comment off the seat availability changes.                                //
  //        otherwise, use existing changes start - existing changes end                 //
  /////////////////////////////////////////////////////////////////////////////////////////
  //        Important Reminder : These two cannot coexist. Hence must comment either one.//
  /////////////////////////////////////////////////////////////////////////////////////////

  // existing changes start
  //if (noAuthRouteNames.includes(to.name) || (store.getters.authenticated)) {
  //  if (to.fullPath.includes("mybooking")) {
  //    store.commit("updateNavBarActiveButton", 1);
  //  } else if (to.fullPath.includes("account")) {
  //    store.commit("updateNavBarActiveButton", 2);
  //  } else {
  //    store.commit("updateNavBarActiveButton", 0);
  //  }

  //  next()
  //}
  // existing changes end

  // seat availability changes start
  if (noAuthRouteNames.includes(to.name) || (store.getters.authenticated)) {

    if (to.fullPath.includes("mybooking")) {
      store.commit("updateNavBarActiveButton", 2);
    } 
    else if (to.fullPath.includes("account")) {
      store.commit("updateNavBarActiveButton", 3);
    }
    else if (to.fullPath.includes("seatavailability")) {
      store.commit("updateNavQRCodeActiveButton", 0);
      store.commit("updateNavBarActiveButton", 0);
    } 
    else {
      store.commit("updateNavBarActiveButton", 1);
    }

    next()
  }
  // seat availability changes end

  else {
    // router.replace("/")
    //apiHelper.casAuth(to.name);
    //next({ name: "LoginOptions" });

    //Store current URL before going to CAS auth page
    store.commit("updatePreCasAuthState", {
      routeName: to.name,
      time: moment()
    });

    store.commit("updateLocationInfoFromUrl", {
      currentBranchCode: to.params.branchCode || constants.defaultBranchName
    });

    if (store.getters.gantryAccessQrEnabled && to.fullPath.includes("gantryaccessqr")) {
      next({ name: 'EmailMobileLogin' })
    }
    else {
      next('/login/options');
    }
  }

  if (noCheckInRouteNames.includes(to.name)) {
    store.commit("updateShowCheckIn", false)
  }
  else {
    store.commit("updateShowCheckIn", true)
  }
})

// Include the 'name' of the Route here for the BottomNavigationBar to appear.

// existing changes start
//const showNavBarPages = ["Home", "MyBookings", "Account"]
// existing changes end

// seat availability changes start
const showNavBarPages = ["Home", "MyBookings", "Account", "SeatsAvailabilities"]
const showQRCodeBarPages = ["SeatsAvailability"]
// seat availability changes end

router.afterEach((to, from) => {
  if (showNavBarPages.includes(to.name)) {
    store.commit("updateShowNavBar", true)
  }
  else {
    store.commit("updateShowNavBar", false)
  }
  // seat availability changes start
   if (showQRCodeBarPages.includes(to.name)) {
     store.commit("updateShowQRCodeBar", true)
   }
   else {
     store.commit("updateShowQRCodeBar", false)
   }
  // seat availability changes end
})

export default router
